import React from 'react';
import { LogoMark } from './Logo';
export function SiteFooter() {
  return <footer className="w-full bg-wt-footer-background-color text-white" data-id="element-18" data-mp="3r89bt43culeb">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-4 py-10 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8" data-id="element-19" data-mp="3racd4k9yk0yc">
        <div className="flex items-center gap-3" data-id="element-20" data-mp="3hizlnts2ncsu">
          <LogoMark size={40} label="Friends of Margaret S. Hayward Park" data-id="element-21" data-mp="3hi6bsjxtg76h" />
          <div data-id="element-22" data-mp="3dhw8xg5blwvu">
            <p className="font-semibold" data-id="element-23" data-mp="3difo4p3l6766">Friends of Hayward Park</p>
            <p className="text-sm text-white/60" data-id="element-24" data-mp="38hi6cdmhnf57">For a fun and peaceful park for all.</p>
          </div>
        </div>
        <div className="text-left text-sm text-white/60 sm:text-right" data-id="element-25" data-mp="33jgfh6itmbj6">
          <p data-id="element-26" data-mp="2yk3vctjc3ika">© {new Date().getFullYear()} Friends of Hayward Park SF</p>
          <p className="mt-1" data-id="element-27" data-mp="11rbpw1osnqbm">San Francisco, CA</p>
        </div>
      </div>
    </footer>;
}